import { apiFetch } from "./config.js";
/** Every question HP Genie answered, newest first (admins only). */
export async function listQuestionLog(params = {}) {
    const q = new URLSearchParams();
    if (params.since)
        q.set("since", params.since);
    if (params.until)
        q.set("until", params.until);
    if (params.limit)
        q.set("limit", String(params.limit));
    if (params.withTrace)
        q.set("with_trace", "true");
    const qs = q.toString();
    return apiFetch(`/regulation/chats/log${qs ? `?${qs}` : ""}`);
}
/** One logged question with its whole research trace (admins only). */
export async function getQuestionLogEntry(id) {
    return apiFetch(`/regulation/chats/log/${id}`);
}
/** How often each automatic finding fired over the last `days` days (admins only). The server sends the counts as a list of {code, count}. */
export async function getQuestionLogSummary(days) {
    const raw = await apiFetch(`/regulation/chats/log/summary?days=${days}`);
    return {
        days: raw.days,
        total: raw.questions,
        flagged: raw.flagged,
        by_flag: Object.fromEntries((raw.flags ?? []).map((f) => [f.code, f.count])),
        by_severity: {},
    };
}
/** Admins: runs a question again through the live pipeline (answer cache left out) and returns the id of the log row that holds its whole trace. Takes a minute or two. */
export async function analyseQuestion(question, signal) {
    let job = await apiFetch("/regulation/chats/log/analyse", { method: "POST", body: { question }, signal });
    const deadline = Date.now() + 8 * 60 * 1000;
    while (true) {
        if (Date.now() > deadline)
            throw new Error("The analysis is taking longer than expected. Look for the question in Genie questions in a few minutes.");
        await new Promise((resolve) => setTimeout(resolve, 3000));
        const got = await apiFetch(`/regulation/ask/jobs/${job.id}`, { signal });
        if (got.status === "failed")
            throw new Error(got.error || "The question could not be analysed.");
        if (got.status === "done") {
            if (!got.response?.log_id)
                throw new Error("The question was answered but its trace was not saved.");
            return got.response.log_id;
        }
        job = got;
    }
}
